import _ from 'lodash';
import React from 'react';

import './styles.css';

const UPCOMING = 'Upcoming';
const DUE_IN = 'Due in';
const IN_HOUSE = 'In house';
const ONGOING = 'Ongoing';
const DUE_OUT = 'Due out';
const CHECKED_OUT = 'Checked out';
const CANCELLED = 'Cancelled';
const NO_SHOW = 'No show';

interface BookingSetStatusTagProps {
  status: string;
}

const STATUS_TO_COLOR_MAPPER = {
  [ONGOING]: {
    backgroundColor: '#D4F1CA',
    textColor: '#228100',
    borderColor: '#5FBA3F'
  },
  [CANCELLED]: {
    backgroundColor: '#E1E8F0',
    textColor: '#6E7B8C',
    borderColor: '#d2d9e2'
  },
  [DUE_OUT]: {
    backgroundColor: '#FFC9C9',
    textColor: '#C14747',
    borderColor: '#C14747'
  },
  [IN_HOUSE]: {
    backgroundColor: '#CCEBFF',
    textColor: '#0C6AA6',
    borderColor: '#0C6AA6'
  },
  [UPCOMING]: {
    backgroundColor: '#A5DCFF',
    textColor: '#0070B9',
    borderColor: '#0070B9'
  },
  [CHECKED_OUT]: {
    backgroundColor: '#FFE1E1',
    textColor: '#AB4F4F',
    borderColor: '#AB4F4F'
  },
  [DUE_IN]: {
    backgroundColor: '#49EEE9',
    textColor: '#006A67',
    borderColor: '#006A67'
  },
  [NO_SHOW]: {
    backgroundColor: '#FFC6E2',
    textColor: '#BB427E',
    borderColor: '#BB427E'
  }
};

const BookingSetStatusTag = ({status}: BookingSetStatusTagProps) => {
  const {backgroundColor, textColor, borderColor} = _.get(
    STATUS_TO_COLOR_MAPPER,
    status,
    {}
  );

  return (
    <div
      className="BookingSetStatusTag colab-centered colab-bold"
      style={{
        backgroundColor,
        borderColor,
        color: textColor
      }}>
      {status}
    </div>
  );
};

export default BookingSetStatusTag;
